import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
  };

  return (
    <Button
      variant="ghost"
      onClick={toggleLanguage}
      className="flex items-center gap-2 text-slate-400 hover:text-white hover:bg-slate-700/50 px-3 py-2"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-medium uppercase">
        {i18n.language === 'en' ? 'ES' : 'EN'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;
